var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header-second maincolumn"},[_c('b-img',{staticClass:"navbarLogo",attrs:{"src":require('../../assets/img/achclogonavigator.svg'),"fluid":"","alt":"ACHC Logo","width":"187"},on:{"click":_vm.goToDashboard}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }